export const DRY_FOOD = 'dry';
export const WET_FOOD = 'wet';
export const RELATED = 'supplement';
export const SNACKS = 'snack';